<template>
  <div class="blog">
    <div class="author-wrapper">
      <div class="other-way" v-if="blog.blog.audio || blog.blog.video">
        <span class="txt">Another way to experience</span>
        <div class="acts">
          <span class="ico" @click="showBlogVideo" v-if="blog.blog.video">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M23.4576 6.11084C23.7907 6.28224 24 6.62542 24 7V17C24 17.3746 23.7907 17.7178 23.4576 17.8892C23.1245 18.0606 22.7236 18.0315 22.4188 17.8137L15.4188 12.8137C15.156 12.626 15 12.323 15 12C15 11.6771 15.156 11.374 15.4188 11.1863L22.4188 6.18627C22.7236 5.96855 23.1245 5.93943 23.4576 6.11084ZM17.7205 12L22 15.0568V8.94319L17.7205 12Z"
                fill="#A1B1BA"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3 6C2.44772 6 2 6.44772 2 7V17C2 17.5523 2.44772 18 3 18H14C14.5523 18 15 17.5523 15 17V7C15 6.44772 14.5523 6 14 6H3ZM0 7C0 5.34315 1.34315 4 3 4H14C15.6569 4 17 5.34315 17 7V17C17 18.6569 15.6569 20 14 20H3C1.34315 20 0 18.6569 0 17V7Z"
                fill="#A1B1BA"
              />
            </svg>
          </span>
          <span class="ico" @click="handleAudioPanel" v-if="blog.blog.audio">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.9121 4C10.7904 4 8.75555 4.84285 7.25525 6.34315C5.75496 7.84344 4.91211 9.87827 4.91211 12V18C4.91211 18.5523 4.46439 19 3.91211 19C3.35982 19 2.91211 18.5523 2.91211 18V12C2.91211 9.34784 3.96568 6.8043 5.84104 4.92893C7.7164 3.05357 10.2599 2 12.9121 2C15.5643 2 18.1078 3.05357 19.9832 4.92893C21.8585 6.8043 22.9121 9.34784 22.9121 12V18C22.9121 18.5523 22.4644 19 21.9121 19C21.3598 19 20.9121 18.5523 20.9121 18V12C20.9121 9.87827 20.0693 7.84344 18.569 6.34315C17.0687 4.84285 15.0338 4 12.9121 4Z"
                fill="#A1B1BA"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.91211 14C2.91211 13.4477 3.35982 13 3.91211 13H6.91211C7.70776 13 8.47082 13.3161 9.03343 13.8787C9.59604 14.4413 9.91211 15.2044 9.91211 16V19C9.91211 19.7957 9.59604 20.5587 9.03343 21.1213C8.47082 21.6839 7.70776 22 6.91211 22H5.91211C5.11646 22 4.3534 21.6839 3.79079 21.1213C3.22818 20.5587 2.91211 19.7957 2.91211 19V14ZM4.91211 15V19C4.91211 19.2652 5.01747 19.5196 5.205 19.7071C5.39254 19.8946 5.64689 20 5.91211 20H6.91211C7.17733 20 7.43168 19.8946 7.61922 19.7071C7.80675 19.5196 7.91211 19.2652 7.91211 19V16C7.91211 15.7348 7.80675 15.4804 7.61922 15.2929C7.43168 15.1054 7.17733 15 6.91211 15H4.91211ZM18.9121 15C18.6469 15 18.3925 15.1054 18.205 15.2929C18.0175 15.4804 17.9121 15.7348 17.9121 16V19C17.9121 19.2652 18.0175 19.5196 18.205 19.7071C18.3925 19.8946 18.6469 20 18.9121 20H19.9121C20.1773 20 20.4317 19.8946 20.6192 19.7071C20.8068 19.5196 20.9121 19.2652 20.9121 19V15H18.9121ZM16.7908 13.8787C17.3534 13.3161 18.1165 13 18.9121 13H21.9121C22.4644 13 22.9121 13.4477 22.9121 14V19C22.9121 19.7957 22.596 20.5587 22.0334 21.1213C21.4708 21.6839 20.7078 22 19.9121 22H18.9121C18.1165 22 17.3534 21.6839 16.7908 21.1213C16.2282 20.5587 15.9121 19.7957 15.9121 19V16C15.9121 15.2043 16.2282 14.4413 16.7908 13.8787Z"
                fill="#A1B1BA"
              />
            </svg>
          </span>
        </div>
      </div>
      <transition name="fade">
        <div class="author-card" v-if="sideCard">
          <div class="author">
            <div @click="handleBloggerProfileClick" class="profile">
              <img
                v-if="blog.blogger && blog.blogger.imgURL"
                :src="blog.blogger.imgURL"
                :alt="
                  `${blog.blogger.firstname} ${blog.blogger.lastname} picture`
                "
              />
              <div>
                <h3 class="name" v-if="blog.blogger && blog.blogger.firstname">
                  {{ blog.blogger.firstname + " " + blog.blogger.lastname }}
                </h3>
                <span
                  class="email"
                  v-if="blog.blogger && blog.blogger.profileName"
                >
                  @{{ blog.blogger.profileName }}
                </span>
              </div>
            </div>
            <p class="author-details">
              {{ bloggerProfileBio }}
            </p>
            <button
              class="btn btn-follow"
              :class="isFollowed ? 'followed' : ''"
              @click="toggleFollowBlogger"
            >
              <span v-if="!isFollowed">Follow</span>
              <span v-else>Following</span>
            </button>
          </div>
          <div class="horizontal-line"></div>
          <div class="stats">
            <div class="handshakes">
              <span class="ico clap" @click="handleHandshakeClick">
                <template>
                  <vLottiePlayer
                    height="70px"
                    width="70px"
                    name="clap"
                    :autoplay="false"
                    loop
                    @animControl="anim => (clap = anim)"
                    :animationData="require('@/assets/Hand-Shaking.json')"
                  />
                </template>
              </span>
              <span
                class="text"
                v-if="blog.feedback && blog.feedback.thankyous"
              >
                {{
                  blog.feedback.thankyous.length
                    ? blog.feedback.thankyous.length
                    : ""
                }}
              </span>
            </div>
            <div class="handshakes" @click="showComments">
              <span class="ico">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.49967 24.017L7.68334 19.8333H20.9997C21.6185 19.8333 22.212 19.5875 22.6496 19.1499C23.0872 18.7123 23.333 18.1188 23.333 17.5V7C23.333 6.38116 23.0872 5.78767 22.6496 5.35008C22.212 4.9125 21.6185 4.66667 20.9997 4.66667H5.83301C5.21417 4.66667 4.62068 4.9125 4.18309 5.35008C3.74551 5.78767 3.49967 6.38116 3.49967 7V24.017ZM3.49967 25.6667H2.33301V7C2.33301 6.07174 2.70176 5.1815 3.35813 4.52513C4.01451 3.86875 4.90475 3.5 5.83301 3.5H20.9997C21.9279 3.5 22.8182 3.86875 23.4745 4.52513C24.1309 5.1815 24.4997 6.07174 24.4997 7V17.5C24.4997 18.4283 24.1309 19.3185 23.4745 19.9749C22.8182 20.6313 21.9279 21 20.9997 21H8.16634L3.49967 25.6667Z"
                    fill="#8D99A0"
                  />
                </svg>
              </span>
              <span class="text" v-if="blog.feedback && blog.feedback.feedback">
                {{
                  blog.feedback.feedback.length
                    ? blog.feedback.feedback.length
                    : ""
                }}
              </span>
            </div>
            <div class="handshakes">
              <span class="ico" @click="toggleBookMark">
                <template v-if="!isBookMarked">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.33301 3.5H18.6663C19.5946 3.5 20.4848 3.86875 21.1412 4.52513C21.7976 5.1815 22.1663 6.07174 22.1663 7V24.5L13.9997 21L5.83301 24.5V7C5.83301 6.07174 6.20176 5.1815 6.85813 4.52513C7.51451 3.86875 8.40475 3.5 9.33301 3.5ZM9.33301 4.66667C8.71417 4.66667 8.12068 4.9125 7.68309 5.35008C7.24551 5.78767 6.99967 6.38116 6.99967 7V22.7383L13.9997 19.7657L20.9997 22.7372V7C20.9997 6.38116 20.7538 5.78767 20.3163 5.35008C19.8787 4.9125 19.2852 4.66667 18.6663 4.66667H9.33301Z"
                      fill="#8D99A0"
                    />
                  </svg>
                </template>
                <template v-else>
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19 4.125H9C7.9 4.125 7 5.0625 7 6.20833V22.875L14 19.75L21 22.875V6.20833C21 5.0625 20.1 4.125 19 4.125Z"
                      fill="#52595E"
                    />
                    <path
                      d="M9.33301 3.5H18.6663C19.5946 3.5 20.4848 3.86875 21.1412 4.52513C21.7976 5.1815 22.1663 6.07174 22.1663 7V24.5L13.9997 21L5.83301 24.5V7C5.83301 6.07174 6.20176 5.1815 6.85813 4.52513C7.51451 3.86875 8.40475 3.5 9.33301 3.5ZM9.33301 4.66667C8.71417 4.66667 8.12068 4.9125 7.68309 5.35008C7.24551 5.78767 6.99967 6.38116 6.99967 7V22.7383L13.9997 19.7657L20.9997 22.7372V7C20.9997 6.38116 20.7538 5.78767 20.3163 5.35008C19.8787 4.9125 19.2852 4.66667 18.6663 4.66667H9.33301Z"
                      fill="white"
                    />
                  </svg>
                </template>
              </span>
              <span class="text">
                {{ countBookmarks ? countBookmarks : "" }}
              </span>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="wrapper">
      <h2 v-if="loading" class="title">
        <b-skeleton animation="wave" width="100%" height="35px"></b-skeleton>
        <b-skeleton
          class="mt-3"
          animation="wave"
          width="60%"
          height="35px"
        ></b-skeleton>
      </h2>
      <h2 v-else class="title">{{ blogTitle }}</h2>
      <blog-header
        :blog="blog"
        :loading="loading"
        :isFollowed="isFollowed"
        @followClicked="toggleFollowBlogger"
      />
      <template v-if="articleContent">
        <div v-if="articleContent" v-html="articleContent" class="content" />
      </template>
      <div v-else>
        <br />
        <b-skeleton animation="wave" width="100%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="85%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="75%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="95%" height="20px"></b-skeleton>
        <br />
        <b-skeleton-img no-aspect height="400px" />
        <br />
        <b-skeleton animation="wave" width="100%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="70%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="85%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="100%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="70%" height="20px"></b-skeleton>
        <br />
        <b-skeleton animation="wave" width="100%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="85%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="70%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="55%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="70%" height="20px"></b-skeleton>
        <br />
        <b-skeleton animation="wave" width="100%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="85%" height="20px"></b-skeleton>
        <b-skeleton animation="wave" width="70%" height="20px"></b-skeleton>
      </div>
      <div class="tags" v-if="blog.doc && blog.doc.seo">
        <div class="tag" v-for="(tag, i) in blog.doc.seo" :key="i">
          {{ tag }}
        </div>
      </div>
      <BlogFoot :blog="blog" @clapBlog="handlSaveClap" />
      <div class="horizontal-line foot-thumb" />
      <AuthorProfileThumb
        :blog="blog"
        :blogger="blogger"
        :isFollowed="isFollowed"
        @followClicked="toggleFollowBlogger"
      />
      <hr />
      <!-- InArticleAdsense
        data-ad-client="ca-pub-4193943538824548"
        data-ad-slot="9369521116"

      </InArticleAdsense-->
    </div>
    <div class="container full-width-start">
      <template v-if="false">
        <h2 class="recommended" v-if="guides.length > 0">
          Recommended Guides
        </h2>
        <div class="guide-cards">
          <GuideCard v-for="(guide, i) in guides" :key="i" :aGuide="guide" />
        </div>
      </template>

      <h2 class="recomended-tools" v-if="tools.length > 0">
        Recommended Tools
      </h2>
      <div class="guide-cards">
        <div
          class="tool"
          v-for="(tool, i) in tools"
          :key="i"
          @click="goToTool(tool.name)"
        >
          <div class="first">
            <img v-if="tool.imgURL" :src="tool.imgURL" alt="" />
            <img v-else :src="toolImg" alt="" />
            <h3>{{ tool.name }}</h3>
          </div>
          <p>{{ tool.description }}</p>
        </div>
      </div>
    </div>
    <SidebarBlog :blog="blog" @postedFeedback="getBlog" />

    <VideoModal v-if="!video" />
    <VideoModal
      v-else
      :img="videoThumb"
      :headline="blog.doc.title"
      @closed="video = false"
    />
    <Form />
    <b-alert
      v-model="audioPanel"
      class="position-fixed fixed-bottom m-0 rounded-0"
      style="z-index: 2000;"
      variant="light"
      @dismissed="alertDismissed"
      dismissible
    >
      <b-row>
        <b-col cols="2" offset="1">
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.9121 4C10.7904 4 8.75555 4.84285 7.25525 6.34315C5.75496 7.84344 4.91211 9.87827 4.91211 12V18C4.91211 18.5523 4.46439 19 3.91211 19C3.35982 19 2.91211 18.5523 2.91211 18V12C2.91211 9.34784 3.96568 6.8043 5.84104 4.92893C7.7164 3.05357 10.2599 2 12.9121 2C15.5643 2 18.1078 3.05357 19.9832 4.92893C21.8585 6.8043 22.9121 9.34784 22.9121 12V18C22.9121 18.5523 22.4644 19 21.9121 19C21.3598 19 20.9121 18.5523 20.9121 18V12C20.9121 9.87827 20.0693 7.84344 18.569 6.34315C17.0687 4.84285 15.0338 4 12.9121 4Z"
              fill="#A1B1BA"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.91211 14C2.91211 13.4477 3.35982 13 3.91211 13H6.91211C7.70776 13 8.47082 13.3161 9.03343 13.8787C9.59604 14.4413 9.91211 15.2044 9.91211 16V19C9.91211 19.7957 9.59604 20.5587 9.03343 21.1213C8.47082 21.6839 7.70776 22 6.91211 22H5.91211C5.11646 22 4.3534 21.6839 3.79079 21.1213C3.22818 20.5587 2.91211 19.7957 2.91211 19V14ZM4.91211 15V19C4.91211 19.2652 5.01747 19.5196 5.205 19.7071C5.39254 19.8946 5.64689 20 5.91211 20H6.91211C7.17733 20 7.43168 19.8946 7.61922 19.7071C7.80675 19.5196 7.91211 19.2652 7.91211 19V16C7.91211 15.7348 7.80675 15.4804 7.61922 15.2929C7.43168 15.1054 7.17733 15 6.91211 15H4.91211ZM18.9121 15C18.6469 15 18.3925 15.1054 18.205 15.2929C18.0175 15.4804 17.9121 15.7348 17.9121 16V19C17.9121 19.2652 18.0175 19.5196 18.205 19.7071C18.3925 19.8946 18.6469 20 18.9121 20H19.9121C20.1773 20 20.4317 19.8946 20.6192 19.7071C20.8068 19.5196 20.9121 19.2652 20.9121 19V15H18.9121ZM16.7908 13.8787C17.3534 13.3161 18.1165 13 18.9121 13H21.9121C22.4644 13 22.9121 13.4477 22.9121 14V19C22.9121 19.7957 22.596 20.5587 22.0334 21.1213C21.4708 21.6839 20.7078 22 19.9121 22H18.9121C18.1165 22 17.3534 21.6839 16.7908 21.1213C16.2282 20.5587 15.9121 19.7957 15.9121 19V16C15.9121 15.2043 16.2282 14.4413 16.7908 13.8787Z"
              fill="#A1B1BA"
            />
          </svg>
          Audio
        </b-col>
        <b-col cols="1">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10 19H6V5H10V19ZM14 19V5H18V19H14Z"
              fill="#52595E"
            />
          </svg>
        </b-col>
        <b-col cols="5">
          <b-progress :value="audioValue" :max="audioMax" height="3px" />
          <b-row>
            {{ blog.blog.title }}
          </b-row>
          <b-row> {{ audioCurrentTime }} / {{ audioDuration }} </b-row>
        </b-col>
      </b-row>
    </b-alert>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapGetters } from "vuex";
import axios from "axios";
//import Ads from "vue-google-adsense";
import moment from "moment";
import config from "@/assets/_config.json";
import Form from "@/components/layout/Form";
import VueLottiePlayer from "vue-lottie-player";
import BlogHeader from "@/components/other-pages/Blogs/BlogHeader";
import BlogFoot from "@/components/other-pages/Blogs/BlogFoot";
import AuthorProfileThumb from "@/components/other-pages/Blogs/AuthorProfileThumb";
import GuideCard from "@/components/other-pages/guide/GuideCard";
import SidebarBlog from "@/components/other-pages/Blogs/SidebarBlog";
import VideoModal from "@/components/other-pages/guide/VideoModal";
import RecordViews from "@/mixins/RecordViews";
import Vue from "vue";

//Vue.use(Ads.InArticleAdsense);

export default {
  //This should take in the properties of blog
  name: "Article",
  mixins: [RecordViews],
  components: {
    vLottiePlayer: VueLottiePlayer,
    Form,
    BlogHeader,
    BlogFoot,
    AuthorProfileThumb,
    GuideCard,
    SidebarBlog,
    VideoModal
  },
  beforeMount() {
    this.articleTitle = this.$route.params.blogTitle;
    this.loading = true;
  },
  mounted() {
    this.getBlogData();
    if (this.user) {
      // this.getBookMarks();
      //this.getFollowedBloggers();
    }
    document.addEventListener("scroll", () => {
      this.sideCardDisplay();
    });
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    countBookmarks() {
      let validBookmarks = this.blog.feedback
        ? this.blog.feedback.bookmarks
          ? this.blog.feedback.bookmarks.filter(aBookMark => {
              return aBookMark._deleted_at == null;
            })
          : []
        : [];
      return validBookmarks.length > 0 ? validBookmarks.length : "";
    },
    isBookMarked() {
      let isBookMarked = false;
      this.bookMarks.forEach(bookmark => {
        if (bookmark.id == this.blog.id) {
          isBookMarked = true;
        }
      });
      return isBookMarked;
    },
    isFollowed() {
      let isFollowed = false;
      this.followedBloggers.forEach(blogger => {
        if (blogger.bloggerId == this.blog.blogger.bloggerId) {
          isFollowed = true;
        }
      });
      return isFollowed;
    },
    articleContent() {
      return this.wpData
        ? this.wpData.content
          ? this.wpData.content.rendered
          : "No Content Available"
        : null;
    },
    blogTitle() {
      return this.blog ? (this.blog.blog ? this.blog.blog.title : "") : "";
    },
    blogSummary() {
      return this.blog ? (this.blog.blog ? this.blog.blog.summary : "") : "";
    },
    blogImgURL() {
      return this.blog ? (this.blog.blog ? this.blog.blog.imgURL : "") : "";
    },
    bloggerProfileBio() {
      if (this.blogger && this.blogger.profile && this.blogger.profile.bio) {
        const ellipses =
          this.blogger.profile.bio.length > this.config.limit.blogger_profile
            ? "..."
            : "";
        return `${this.blogger.profile.bio.substr(
          0,
          this.config.limit.blogger_profile
        )} ${ellipses}`;
      }
      return "";
    }
  },
  watch: {
    user(newValue, oldValue) {
      if (newValue.uid) {
        this.getBookMarks();
        // this.getFollowedBloggers();
      }
    },
    blog(newValue, oldValue) {
      if (newValue.blog && newValue.blog.wpId) {
        this.getArticleWPPost(newValue.blog.wpId);

        if (!this.isViewRecorded && newValue.id) {
          this.isViewRecorded = true;
          this.recordView(newValue.id);
        }
      }
    }
  },
  methods: {
    alertDismissed() {
      this.playPauseAudio(false);
    },
    getDuration(seconds) {
      let measuredTime = new Date(null);
      measuredTime.setSeconds(seconds); // specify value of SECONDS
      return measuredTime.toISOString().substr(11, 8);
    },
    getBlogData() {
      this.$store
        .dispatch("listings/getBlogByTitle", this.articleTitle)
        .then(res => {
          this.blog = res;
          this.loading = false;
          if (res.doc.guides && res.doc.guides.length > 0) {
            res.doc.guides.forEach(guide => {
              this.getGuide(guide.profileName);
            });
          }
          if (res.doc.tools && res.doc.tools.length > 0) {
            res.doc.tools.forEach(tool => {
              this.getTool(tool.toolId);
            });
          }
          this.$store
            .dispatch("listings/getBloggerById", res.blogger.bloggerId)
            .then(res => {
              this.blogger = res;
            });
          this.collectTags();
        })
        .catch(e => {
          console.log(e);
        });
    },
    getBlog() {
      this.$store
        .dispatch("listings/getBlogByTitle", this.articleTitle)
        .then(res => {
          this.blog = res;
        })
        .catch(e => {
          console.log(e);
        });
    },
    collectTags() {
      if (!this.user) {
        if (this.blog.doc.seo.length > 0) {
          let existingTags = JSON.parse(Cookies.get("blog_tags"));
          let currentTags = this.blog.doc.seo;
          let allTags = [...existingTags, ...currentTags];
          let uniqTags = [...new Set(allTags)];
          Cookies.set("blog_tags", JSON.stringify(uniqTags));
        }
      } else {
        if (this.blog.doc.seo.length > 0) {
          this.$store.dispatch("user/addBlogTags", this.blog.doc.seo);
        }
      }
    },
    sideCardDisplay() {
      if (
        document.querySelector(".full-width-start").getBoundingClientRect()
          .top -
          110 <=
        0
      ) {
        this.sideCard = true;
      } else if (
        document.querySelector(".content").getBoundingClientRect().top - 110 >
        0
      ) {
        this.sideCard = false;
      }
      if (
        window.innerHeight -
          document.querySelector(".foot-thumb").getBoundingClientRect().top >
        60
      ) {
        this.sideCard = false;
      } else if (
        document.querySelector(".content").getBoundingClientRect().top - 110 <=
          0 &&
        window.innerHeight -
          document.querySelector(".foot-thumb").getBoundingClientRect().top <=
          60
      ) {
        this.sideCard = true;
      }
    },
    handleHandshakeClick() {
      if (!this.user) {
        this.$bvModal.show("loginModal");
      } else {
        clearTimeout(this.timeoutInterval);
        this.clap.stop();
        this.clap.play();
        this.handshakes++;
        this.timeoutInterval = setTimeout(() => {
          this.clap.stop();
        }, 1500);
        this.handlSaveClap();
      }
    },
    handlSaveClap() {
      this.$store
        .dispatch("listings/addClap", {
          userId: this.user.uid,
          blogId: this.blog.id
        })
        .then(() => {
          this.getBlog();
        });
    },
    showBlogVideo() {
      this.video = true;
      this.$bvModal.show("video-modal");
    },
    handleAudioPanel() {
      this.audioPanel = !this.audioPanel;
      this.playPauseAudio(this.audioPanel);
    },
    showComments() {
      this.$root.$emit("bv::toggle::collapse", "sidebar_blog");
    },
    getGuide(name) {
      this.$store
        .dispatch("listings/getGuideByProfileName", name)
        .then(res => {
          if (res) {
            this.guides.push(res);
            console.log(res);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getTool(id) {
      this.$store
        .dispatch("listings/getToolById", id)
        .then(res => {
          if (res) {
            this.tools.push(res);
            console.log(res);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    goToTool(name) {
      this.$router.push(`/tool/${name}`);
    },
    getBookMarks() {
      this.$store
        .dispatch("user/getUserBlogBookMarks", this.user.uid)
        .then(bookMarks => {
          this.bookMarks = bookMarks;
        });
    },
    getFollowedBloggers() {
      /* this.$store
        .dispatch("user/getFollowedBloggers", this.user.uid)
        .then(bloggers => {
          this.followedBloggers = bloggers;
          console.log(this.followedBloggers);
        });*/
    },
    toggleBookMark() {
      if (!this.user) {
        this.$bvModal.show("loginModal");
      } else {
        if (!this.isBookMarked) {
          this.$store.dispatch("user/addBookMarkBlog", this.blog).then(() => {
            //this.getBookMarks();
            console.log("Bookmarked");
          });
          this.$store
            .dispatch("listings/addBookMarkBlog", {
              userId: this.user.uid,
              blogId: this.blog.id
            })
            .then(() => {
              this.getBlog();
            });
        } else {
          this.$store
            .dispatch("user/removeBookMarkBlog", this.blog)
            .then(() => {
              //this.getBookMarks();
              console.log("Removed bookmark");
            });
          this.$store
            .dispatch("listings/removeBookMarkBlog", {
              userId: this.user.uid,
              blogId: this.blog.id
            })
            .then(() => {
              this.getBlog();
            });
        }
      }
    },
    toggleFollowBlogger(data) {
      if (!this.user) {
        this.$bvModal.show("loginModal");
      } else {
        if (!this.isFollowed) {
          this.$store
            .dispatch("user/followBlogger", this.blog.blogger)
            .then(() => {
              this.getFollowedBloggers();
              console.log("Followed");
            });
        } else {
          this.$store
            .dispatch("user/unfollowBlogger", this.blog.blogger)
            .then(() => {
              this.getFollowedBloggers();
              console.log("Unfollowed");
            });
        }
      }
    },
    recordView(blogId) {
      this.$store.dispatch("listings/viewBlog", {
        userId: this.user ? this.user.uid : null,
        blogId: blogId,
        sessionId: this.user ? null : this.checkSession("session")
      });
    },
    async getArticleWPPost(postId) {
      //@TODO - move to a central location - refactor -credentials, etc
      const BASEURL = this.wordPress.baseURL;
      const PATHURLPOSTS = this.wordPress.pathURLPosts;
      const USERNAME = this.wordPress.username;
      const PASSWORD = this.wordPress.password;

      const res = await axios
        .get(`${BASEURL}/${PATHURLPOSTS}/${postId}`, {
          // Axios looks for the `auth` option, and, if it is set, formats a
          // basic auth header for you automatically.
          auth: {
            username: USERNAME,
            password: PASSWORD
          }
        })
        .catch(err => err);

      const vm = this;
      if (res.status === 200) {
        vm.wpData = res.data;
      } else {
        console.log(res.message); // "Request failed with status code 401"
        console.log(res.response.status); // 401 "Unauthorized"
      }
    },
    handleBloggerProfileClick() {
      if (this.blogger.profile && this.blogger.profile.profileName) {
        this.$router.push(`/blog/crew/@${this.blogger.profile.profileName}`);
      }
    },
    playPauseAudio(isPlay) {
      if (this.blog.blog.audio) {
        if (!this.audio) {
          this.audio = new Audio(this.blog.blog.audio);
          this.audioDuration = this.getDuration(this.audio.duration);
          let that = this;
          this.audio.addEventListener("updateListener", function() {
            that.audioCurrentTime = that.audio.currentTime.toFixed();
          });
        }
        if (isPlay) {
          this.audio.play();
        } else {
          this.audio.pause();
        }
      }
    },
    onTimeUpdateListener: function() {
      // Update current time
      this.audioCurrentTime = this.audio.currentTime;
    }
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:title", content: this.blogTitle },
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:description", content: this.blogSummary },
        { name: "twitter:image", content: this.logo },
        { property: "og:title", content: this.blogTitle },
        { property: "og:site_name", content: "JourneyBinder" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: this.blogSummary }
      ]
    };
  },
  data() {
    return {
      wordPress:{
        baseURL:'https://public-api.wordpress.com/wp/v2/sites/heartbeatfam.wordpress.com',
        pathURLPosts:'posts',
        pathURLPages:'pages',
        username:'heartbeatfamblog',
        password:'1385Spring!'
      },
      audio: null,
      audioDuration: "00:00:00",
      audioCurrentTime: "00:00:00",
      audioValue: 45,
      audioMax: 100,
      audioPanel: false,
      articleTitle: null,
      loading: false,
      bookmarked: false,
      fetching: false,
      toolImg: require("../../../../assets/img/blogs/Nutrition.svg"),
      sideCard: false,
      handshakes: 122,
      timeoutInterval: null,
      clap: null,
      video: false,
      videoThumb: require("@/assets/img/blogs/blog-img.svg"),
      blog: {},
      blogger: {},
      guides: [],
      tools: [],
      bookMarks: [],
      followedBloggers: [],
      wpData: null,
      isViewRecorded: false,
      config
    };
  },
};
</script>

<style lang="scss" scoped>
.blog {
  padding-top: 72px;
  padding-bottom: 60px;
  @media (min-width: 767px) {
    padding-top: 130px;
  }
  .horizontal-line {
    border-top: 1px solid #ddd;
  }
  .author-wrapper {
    position: relative;
    z-index: 9;
    .other-way {
      background: #ffffff;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 20px;
      position: fixed;
      top: 145px;
      right: 96px;
      .txt {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.03em;
        color: #8d99a0;
      }
      .acts {
        margin-top: 16px;
        display: flex;
        .ico {
          cursor: pointer;
          margin-right: 24px;
          &:hover {
            transform: scale(1.07);
          }
        }
      }
    }
    .author-card {
      position: fixed;
      left: 100px;
      top: 50%;
      transform: translateY(-50%);
      width: 196px;
      z-index: 4;
      .author {
        .profile {
          cursor: pointer;
          display: grid;
          grid-template-columns: 36px 1fr;
          grid-column-gap: 11px;
          align-items: center;
          margin-bottom: 22px;
          img {
            height: 36px;
            width: 36px;
            border-radius: 50%;
            object-fit: cover;
          }
          .name {
            font-style: normal;
            font-weight: 600;
            font-size: 20px;
            line-height: 26px;
            color: #474d52;
            margin-bottom: 0px;
          }
          .email {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.03em;
            text-decoration-line: underline;
            color: #8d99a0;
          }
        }
        .btn-follow {
          border: 1px solid #474d52;
          box-sizing: border-box;
          border-radius: 4px;
          width: 70px;
          height: 28px;
          padding: 0px;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #474d52;
          background-color: #fff;
          transition: 0.2s ease;
          margin-bottom: 24px;
          &:focus {
            box-shadow: none !important;
          }
          &:hover {
            background-color: #474d52;
            color: #fff;
            &:after,
            &:before {
              content: none;
            }
          }
        }
        .followed {
          width: 76px;
          color: #fff;
          background: #474d52;
        }
      }
      .stats {
        margin-top: 4px;

        .handshakes {
          height: 28px;
          margin-top: 20px;
          display: grid;
          grid-template-columns: 28px 1fr;
          grid-column-gap: 8px;
          .ico {
            &.clap {
              transform: translate(-20px, -33px);
            }
            //margin-right: 8px;
            user-select: none;

            cursor: pointer;
            position: relative;
            .animation- {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -66%) !important;
              svg {
                height: 60px;
                width: 60px;
              }
            }
          }
          .text {
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 19px;
            color: #8d99a0;
            user-select: none;
          }
        }
      }
      .author-details {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
      }
    }
  }
  .wrapper {
    max-width: 728px;
    margin: 0 auto;
    padding-top: 47px;
    @media (max-width: 767px) {
      padding: 0 15px;
    }
    .title {
      font-style: normal;
      font-weight: 600;
      font-size: 40px;
      line-height: 55px;
      color: #474d52;
      margin-bottom: 41px;
      @media (max-width: 767px) {
        font-size: 26px;
        line-height: 34px;
      }
    }
    .content {
      padding-top: 47px;
      font-size: 20px;
      color: #19191a;
      p li {
        font-style: normal;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: 0.03em;
        margin: 0;
      }
    }
    .tags {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      grid-gap: 8px;
      margin-top: 49px;
      margin-bottom: 22px;
      .tag {
        height: 42px;
        background: #ffffff;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
        border-radius: 48px;
        padding: 10px 16px;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        cursor: pointer;
        &:hover {
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
  .recommended {
    margin-top: 99px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    color: #474d52;
    margin-bottom: 24px;
  }
  .guide-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-column-gap: 32px;
    &.recommended-cards {
      margin-bottom: 66px;
    }
  }
  .recomended-tools {
    margin-top: 66px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    color: #474d52;
    margin-bottom: 24px;
  }
  .tool {
    padding: 18px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    .first {
      display: grid;
      grid-template-columns: 32px 1fr;
      grid-column-gap: 8px;
      align-items: center;
      margin-bottom: 8px;
      img {
        height: 32px;
        width: 32px;
        object-fit: cover;
      }
      h3 {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        margin: 0;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #474d52;
      }
    }
  }
}
@media (max-width: 1198px) {
  .author-wrapper {
    visibility: hidden !important;
  }
}
</style>
